import { GenerateWebPreviewUrlInput, GenerateWebPreviewUrlOutput } from "@cruisen/contract"
import { callFirebaseFunction } from "../callFirebaseFunction"

export const generateWebPreviewUrl = async (payload: GenerateWebPreviewUrlInput) => {
  try {
    const response = await callFirebaseFunction({
      name: "generateWebPreviewUrl",
      payload: {
        ...payload,
      },
    })

    return (response.data as unknown as GenerateWebPreviewUrlOutput)?.result
  } catch (error) {
    console.error("Failed to generate web preview url", error)
    return undefined
  }
}
